module.exports = __webpack_public_path__ + "img/family-9.657582eb.jpg";